import React, { useContext, useState } from "react";
import MaterialContext from "../context/material/materialContext";
import Modal from "../component/Modal";
import Button from "../component/Button";
import FacilityList from "./FacilityList";

export default function FacilitySelector({ proc }) {
  const materialContext = useContext(MaterialContext);

  const { facility, getFacilities } = materialContext;

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div style={selectorSytle}>
      {facility ? (
        <Button
          className={`btn btn-${proc}`}
          text={`To: ${facility.name}`}
          onClick={async () => {
            await getFacilities();
            handleOpen();
          }}
        />
      ) : (
        <Button
          className={`btn btn-${proc}`}
          text="To Facility"
          onClick={async () => {
            await getFacilities();
            handleOpen();
          }}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        component={<FacilityList />}
        proc="solid-bg-modal"
      />
    </div>
  );
}

const selectorSytle = {
  marginTop: "10px",
};
